import React from "react"
import { graphql } from "gatsby"
import RedesignLayout from "../components/redesign/RedesignLayout"
import Seo from "../components/seo"
import TopBanner from "../components/MeetCioAndItExecutives/TopBanner/TopBanner"
import TransparentHeader from "../components/GlobalComponents/TransparentHeader/TransparentHeader"
import MeetCioFooter from "../components/MeetCioAndItExecutives/Footer/Footer"
import ExploreMill from "../components/redesign/Home/ExploreMill/ExploreMill"
import CharitiesSwiper from "../components/GlobalComponents/CharitySwiper/CharitySwiper"
import * as charityStyles from "../components/GlobalComponents/CharitySwiper/CharitySwiper.module.css"
import HeroBanner from "../components/redesign/EAAS/HeroBanner/HeroBanner"
import CommunityDinners from "../components/redesign/EAAS/CommunityDinners/CommunityDinners"
import EaasMembersVideos from "../components/redesign/EAAS/MembersVideos/MembersVideos"
import NetworkCategories from "../components/redesign/EAAS/NetworkCategories/NetworkCategories"
import KeyBenefits from "../components/redesign/EAAS/KeyBenefits/KeyBenefits"
import CommunitySection from "../components/redesign/EAAS/CommunitySection/CommunitySection"
import EventFormat from "../components/redesign/EAAS/EventFormat/EventFormat"
import OurPartners from "../components/redesign/Home/OurPartners/OurPartners"
import RelatedAssemblies from "../components/redesign/SingleEvent/RelatedAssemblies/RelatedAssemblies"

export default function EaasRedesign({ data }) {
  const { title, metaDesc } = data?.wpPage?.seo
  const pagedata = data?.wpPage?.aCFeaasPage
  const featuredEvents = {
    edges: (data?.featuredAssembly?.edges ?? []).map(edge => ({
      event: edge.post,
    })),
  }

  return (
    <RedesignLayout>
      <Seo title={title} description={metaDesc} />
      <TopBanner />
      <div style={{ position: "relative" }}>
        <TransparentHeader showMenu={true} />
        <HeroBanner data={pagedata} />
      </div>
      <OurPartners data={pagedata} />
      <CommunityDinners data={pagedata} isEaas={true} />
      <EaasMembersVideos data={pagedata} />
      <NetworkCategories data={pagedata} />
      <KeyBenefits data={pagedata} />
      <EventFormat data={pagedata} />
      <CommunitySection data={pagedata} isEaas />
      {/* <RelatedAssemblies
        events={featuredEvents}
        title="Upcoming Events"
        highlight="Events"
        filterByType={false}
        upcomingOnly={false}
      /> */}
      <ExploreMill
        excludeLinks={["events-as-a-service", "/eaas"]}
      />
      <MeetCioFooter />
    </RedesignLayout>
  )
}

export const pagequery = graphql`
  query EaasRedesign {
    wpPage(slug: { eq: "eaas" }) {
      title
      seo {
        metaDesc
        title
      }
      aCFeaasPage {
        cdHeroImage {
          node {
            publicUrl
            sourceUrl
          }
        }
        contactBackground {
          node {
            publicUrl
            sourceUrl
          }
        }
        contactDetails
        contactTitle
        eventFormatAgenda {
          eventFormatDate
          eventFormatTitle
          fieldGroupName
        }
        eventFormatBg {
          node {
            publicUrl
            sourceUrl
          }
        }
        eventFormatLeftImage {
          node {
            publicUrl
            sourceUrl
          }
        }
        eventFormatTitle
        executiveNetworkRow {
          executiveCompany
          executiveName
          executivePosition
          executivePositionUnderImage
          fieldGroupName
          meetOurNetworkCtaLink {
            title
            url
          }
          supplyChainCtaText
          supplyChainLeadersDescription
          viewWorkbookCtaLink {
            title
            url
          }
          executiveImageLogo {
            node {
              publicUrl
              sourceUrl
            }
          }
        }
        executiveNetworkTitle
        executiveNetworkContactCardTitle
        executiveNetworkContactCardDescription
        executiveNetworkContactCardIcon {
          node {
            publicUrl
            sourceUrl
          }
        }
        executiveNetworkContactCardLink
        heroTitle
        identifyKeyTargetsTitle
        identifyKeyTargetsImage {
          node {
            publicUrl
            sourceUrl
          }
        }
        learnMoreTitle
        whyMillenniumCommunityTitle
        whyMillenniumCommunityImageLeft {
          node {
            publicUrl
            sourceUrl
          }
        }
        heroLogo {
          node {
            publicUrl
            sourceUrl
          }
        }
        heroSubtitle {
          fieldGroupName
          heroSubtitleContent
        }
        keyBenefitsBlock {
          keyBenefitsContent
          keyBenefitsTitle
        }
        homePartnersRedesignEaas {
          partnerLink
          partnerLogo {
            node {
              publicUrl
              sourceUrl
            }
          }
        }
        homePartners {
          partnerLink
          partnerLogo {
            node {
              publicUrl
              sourceUrl
            }
          }
        }
        learnBgImage {
          node {
            publicUrl
            sourceUrl
          }
        }
        whyMillenniumCommunityColRow {
          content
          title
          iconHoverImage {
            node {
              publicUrl
              sourceUrl
            }
          }
          iconImage {
            node {
              publicUrl
              sourceUrl
            }
          }
        }
        learnMoreCtaButton {
          title
          url
        }
        eaasWhatMembersAreSaying
        eaasWhatMembersAreSayingDescription
        testimonialFirstYoutubeVideoUrlEaas
        testimonialFirstYoutubeVideoTitle
        testimonialFirstYoutubeVideoDescription
        testimonialFirstYoutubeVideoImageEaas {
          node {
            publicUrl
            sourceUrl
          }
        }
        testimonialsEaas {
          videoTitle
          videoDescription
          youtubeVideoUrl
          youtubeVideoImage {
            node {
              publicUrl
              sourceUrl
            }
          }
        }
        eaasMembersLearnMoreCtaButton {
          title
          url
        }
      }
    }
    featuredAssembly: allWpEvent(
      filter: {
        uri: { eq: "/assemblies/cornerstone-ondemand-assembly-may-2026/" }
        status: { eq: "publish" }
      }
    ) {
      edges {
        post: node {
          uri
          title
          menuOrder
          status
          aCFevent {
            startDate
            date
            citySelector {
              nodes {
                ... on WpCity {
                  title
                  aCFcity {
                    cityName
                    location
                  }
                }
              }
            }
            eventTopImage {
              node {
                publicUrl
                sourceUrl
              }
            }
          }
          featuredImage {
            node {
              publicUrl
              sourceUrl
            }
          }
        }
      }
    }
  }
`
